var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 10.7843H5.5C4.95 10.7843 4.5 10.3058 4.5 9.72099C4.5 9.13618 4.95 8.6577 5.5 8.6577H9.5C10.05 8.6577 10.5 9.13618 10.5 9.72099C10.5 10.3058 10.05 10.7843 9.5 10.7843ZM15.5 10.7843H13.5C12.95 10.7843 12.5 10.3058 12.5 9.72099C12.5 9.13618 12.95 8.6577 13.5 8.6577H15.5C16.05 8.6577 16.5 9.13618 16.5 9.72099C16.5 10.3058 16.05 10.7843 15.5 10.7843ZM18.5 11.8476C18.5 12.4334 18.052 12.9109 17.5 12.9109H3.5C2.948 12.9109 2.5 12.4334 2.5 11.8476V6.53111H18.5V11.8476ZM2.5 3.34124C2.5 2.75537 2.948 2.27795 3.5 2.27795H17.5C18.052 2.27795 18.5 2.75537 18.5 3.34124V4.40453H2.5V3.34124ZM17.5 0.151367H3.5C1.846 0.151367 0.5 1.58256 0.5 3.34124V11.8476C0.5 13.6063 1.846 15.0374 3.5 15.0374H17.5C19.154 15.0374 20.5 13.6063 20.5 11.8476V3.34124C20.5 1.58256 19.154 0.151367 17.5 0.151367Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.0b2d86800683ac6bca8f44ae6ee9726c.svg";
export { ForwardRef as ReactComponent };